// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD74ts4k-z9PL9YFcOVf4K5vZwCJB7oRb8',
  authDomain: 'djcsi-temp-2021.firebaseapp.com',
  databaseURL: 'https://djcsi-temp-2021-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'djcsi-temp-2021',
  storageBucket: 'djcsi-temp-2021.appspot.com',
  messagingSenderId: '5408482451',
  appId: '1:5408482451:web:ebc22563a236caa2955966',
  measurementId: 'G-R6HKNQP80E',
}

export default firebaseConfig
